import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { Configuration } from 'src/app/configuration';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.css']
})
export class PdfViewerComponent implements OnInit {
  pdfSrc="";

 constructor(private router:Router,private route:ActivatedRoute) {
     this.pdfSrc=localStorage.getItem(Configuration.localStorageData.pdfPath);
  }

  ngOnInit() {
    

  }

}
